// NumericStepperControlView.js

import { View } from 'backbone';
import eventBus         from 'EventBus.js';

import BaseControlView from 'BaseControlView.js';
import constants        from "Constants.js";
import template from 'advanced-inputs/control_numeric_stepper.ejs';

//=====================================================================
//
// An instance of this view represents a numeric stepper control
//
// Maty Rocha, February 16, 2016
//
//=====================================================================
class NumericStepperControlView extends BaseControlView  {

    initialize( opts ) {

        super.initialize( opts );

        this.template = template;
        this.tagName = 'div';
        this.family = constants.CONTROL_ADVANCED_INPUTS;
        this.icon = 'pf-numeric-stepper';

        this.listenTo( eventBus, 'InputThemeChange', this.themeChangeRender );
        this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);
        return this;
    }

    // Neighbor aligner uses this polymorphic property, looking for
    // value 'BaseStaticTextControl'
    get kind() {
        return 'NumericStepperControlView';
    }


}

export default NumericStepperControlView;

